(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nuala-daily-countdown"] && !Shopify.designMode) return;
  try {
    
(() => {
const fmt = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Dublin',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
const parts = date => Object.fromEntries(fmt.formatToParts(date).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));
const wall = p => Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);
function remaining(now) {
 const p=parts(now), target=Date.UTC(p.year,p.month-1,p.day,23,59,59);
 let end=target;
 for(let i=0;i<3;i++) end += target-wall(parts(new Date(end)));
 return Math.max(0,Math.floor((end-now.getTime())/1000));
}
function tick(){
 const left=remaining(new Date());
 const values=[Math.floor(left/3600),Math.floor(left/60)%60,left%60];
 document.querySelectorAll('[data-nuala-daily-timer]').forEach(timer=>{
 timer.querySelectorAll('[data-unit]').forEach((el,i)=>{el.textContent=String(values[i]).padStart(2,'0');});
 timer.hidden=false;
 });
}
if(window.nualaDailyTimer) clearInterval(window.nualaDailyTimer);
tick();window.nualaDailyTimer=setInterval(tick,1000);
document.addEventListener('shopify:section:load',tick);
})();

  } catch(e) { console.error(e); }
})();
})();
